import React from 'react'
import { Typography } from '@mui/material'
import { EnrichedWarrantEntity } from 'types/WarrantEntity'

export function AdjustPriceBlock() {
    return (
        <Typography variant='body1'>
            Vid eventuella nyemissioner innan teckningsperiodens start ska teckningskursen justeras till
            emissionskursen.
        </Typography>
    )
}

export function ExternalCommentBlock({ externalComment }: Pick<EnrichedWarrantEntity, 'externalComment'>) {
    return (
        <div style={{ whiteSpace: 'pre-line' }}>
            <Typography variant='body1'>{externalComment}</Typography>
        </div>
    )
}

export const warrantOtherInfoHasContent = (
    warrant: Pick<EnrichedWarrantEntity, 'externalComment' | 'issuesAdjustPrice'>,
    sources: Array<unknown>,
) => {
    return (warrant.externalComment || warrant.issuesAdjustPrice || sources.length > 0) ?? false
}
